<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col align="center" xs="12" md="10" lg="8">
        <verify-email v-if="mode == 'verifyEmail'"></verify-email>
        <reset-password :actionCode="oobCode" v-if="mode == 'resetPassword'"></reset-password>
        <unlogged-user v-if="!mode"></unlogged-user>
        <h2  v-if="errorMessage" style="color:red;">{{errorMessage}}</h2>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.active"
      vertical
      bottom
      :color="snackbar.color"
      :timeout="8000"
    >
      <span v-text="snackbar.text" class="white--text subtitle-2 font-weight-regular"></span>
      <v-btn icon color="white" @click="snackbar.active = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
const VerifyEmail = () => import('../components/verifyEmail')
const ResetPassword = () => import('../components/resetPassword')
const UnloggedUser = () => import('../components/unloggedUser')

export default {
  name: 'auth',
  props: [
    'mode',
    'oobCode',
    'apiKey',
    'lang'
  ],
  components: {
    VerifyEmail,
    ResetPassword,
    UnloggedUser
  },
  data () {
    return {
      snackbar: {
        color: 'info',
        text: '',
        active: false
      }
    }
  },
  watch: {
    successMessage (val) {
      if (val) {
        this.snackbar.text = val
        this.snackbar.color = 'success'
        this.snackbar.active = true
      }
    },
    errorMessage (val) {
      if (val) {
        this.snackbar.text = val
        this.snackbar.color = 'error'
        this.snackbar.active = true
      }
    }
  },
  computed: {
    errorMessage () {
      return this.$store.getters.errorMessage
    },
    successMessage () {
      return this.$store.getters.successMessage
    }
  },
  mounted () {
    switch (this.mode) {
      case 'resetPassword':
        this.handleResetPassword()
        break
      case 'verifyEmail':
        this.handleVerifyEmail()
        break
    }
  },
  methods: {
    handleResetPassword () {},
    handleVerifyEmail () {
      setTimeout(() => {
        this.$store.dispatch('verificarEmail', this.oobCode)
      }, 1000)
    }
  }
}
</script>
